import React from 'react';
import './ButtonContactUs.css';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const ButtonContactUs = () => {

    const location = useLocation();

    return (
        <>
        {location.pathname === "/Devis" ?         
            <a href='#formulaire' className='buttonContactUs' >
                CONTACTEZ-NOUS <span style={{fontSize: "20px"}}>&gt;</span>
            </a> 
        :
            <Link to={"/Devis#formulaire"} className='buttonContactUs' >
                CONTACTEZ-NOUS <span style={{fontSize: "20px"}}>&gt;</span>
            </Link>
        }
        </>
    )
};

export default ButtonContactUs;